const TYPEHEADER = {
  success: 'success',
  warning: 'warning',
};

export default { TYPEHEADER };
